<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h-outTabs'>
        <ejs-tab id='eventLogTab' ref='tabRef' :showCloseButton='true' heightAdjustMode='Auto' :removing='beforeRemoving' :selected='selectedTab'>
          <e-tabitems>
            <e-tabitem :header='tab.headerText' content='#eventLogTable' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.headerTexts' content='#staticsChar'></e-tabitem>
          </e-tabitems>
        </ejs-tab>
        <div id='eventLogTable' class='h100vh-140'>
          <EventLogButton @notice='notice' @isOn='changeIsOn' @keywords='changeKeywords'></EventLogButton>
          <EventLogTable :roleNe='roleNetList' ref='eventLogTable'></EventLogTable>
        </div>
        <div id='staticsChar' class='h100vh-140' style='display: none;'>
          <StaticsChar :roleNe='roleNetList' ref='staticsCharRef' url='/lte/ems/fm/event/getStatisticsInfo' :option='charOption'></StaticsChar>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import EventLogButton from '../../components/alarmconfig/eventLog/EventLogTableButton';
import EventLogTable from '../../components/alarmconfig/eventLog/EventLogTable';
import StaticsChar from '../../components/alarmconfig/eventLog/StatisticsChar';

export default {
  name: 'EventLogPage',
  components: {
    BasicLayout,
    EventLogButton,
    EventLogTable,
    StaticsChar
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.eventLog')}`
      },
      tab: {
        headerText: { text: this.$t('Alarm.eventLog') },
        headerTexts: { text: this.$t('Alarm.statistics') }
      },
      charOption: {
        charTitle: `${this.$t('Alarm.event')} ${this.$t('Alarm.statistics')}`,
        allNumTitle: this.$t('Alarm.eventNum')
      },
      roleNetMap: {},
      roleNetList: []
    };
  },
  methods: {
    changeIsOn(args) {
      this.$refs.eventLogTable.isOn = args;
    },
    changeKeywords(args) {
      this.$refs.eventLogTable.queryConditions.keywords = args;
    },
    staticsTabFunc() {
      const tabObj = this.$refs.tabRef.ej2Instances;
      tabObj.hideTab(1, false);
      tabObj.select(1);
      this.$refs.staticsCharRef.getStatisData(true);
    },
    selectedTab(args) {
      if (args.selectedIndex === 1) {
        this.right.crumb = `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.eventLog')}/${this.$t('Alarm.statistics')}`;
      } else {
        this.right.crumb = `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.eventLog')}`;
      }
    },
    beforeRemoving(args) {
      if (args.removedIndex === 1) {
        args.cancel = true;
        this.$refs.tabRef.ej2Instances.hideTab(1, true);
      }
    },
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.eventLogTable.queryConditions.conditions = '';
          this.$refs.eventLogTable.queryConditions.keywords = '';
          this.$refs.eventLogTable.page.pageNo = 1;
          this.$refs.eventLogTable.getEventLogTableData();
          break;
        case 'refreshTable':
          this.$refs.eventLogTable.getEventLogTableData();
          break;
        case 'conditions':
          this.$refs.eventLogTable.conditionsStatus = true;
          this.$refs.eventLogTable.getEventLogTableData();
          break;
        case 'keywords':
          this.$refs.eventLogTable.conditionsStatus = false;
          this.$refs.eventLogTable.getEventLogTableData();
          break;
        case 'export':
          this.$refs.eventLogTable.exportEventLogData();
          break;
        case 'statistics':
          this.staticsTabFunc();
          break;
        case 'filter':
          this.$refs.eventLogTable.filterFunc();
          break;
        default:
      }
    }
  },
  beforeMount() {
    const This = this;
    This.roleNetMap = {};
    This.roleNetList = [];
    this.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          This.roleNetMap[response.data[i]] = 1;
          This.roleNetList.push(response.data[i]);
        }
      }
    });
  },
  mounted() {
    this.$refs.tabRef.ej2Instances.hideTab(1, true);
  }
};
</script>
